import { gql } from "generated-graphql";

export const GET_RULE_SUGGESTIONS = gql(`
  query RuleSuggestions($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    ruleSuggestions(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        source
        title
        observation
        recommendation
        jurisdiction
        confidence
        provenance
        status
        dismissedAt
        dismissedBy
        dismissReason
        promotedAt
        promotedBy
        linearIssueIdentifier
        linearIssueUrl
        linearStateName
        linearStateType
        linearSyncedAt
        firstSuggestedAt
        lastSuggestedAt
      }
      count
    }
  }
`);

export const REFRESH_RULE_SUGGESTION_LINEAR_STATUSES = gql(`
  mutation RefreshRuleSuggestionLinearStatuses {
    refreshRuleSuggestionLinearStatuses {
      id
      linearStateName
      linearStateType
      linearSyncedAt
    }
  }
`);
